import axios from 'axios';
import Cookies from 'js-cookie';

const types = {
  LOGIN: 'LOGIN',
  LOGIN_FULFILLED: 'LOGIN_FULFILLED',
  LOGIN_REJECTED: 'LOGIN_REJECTED',
  CLEAR_LOGIN_STATUS: 'CLEAR_LOGIN_STATUS'
};

function doPostLogin(code, protocol, hostname) {
  const redierctURL = Cookies.get('redierctURL');
  return () => axios.post('/ssologin', { code, protocol, hostname }).then((response) => {
    if (redierctURL) {
      Cookies.set('redierctURL', redierctURL);
    }
    return response.data;
  })
  // eslint-disable-next-line prefer-promise-reject-errors, no-promise-executor-return
  .catch((error) => new Promise((res, rej) => rej({ error })));
}

function postLogin(code, protocol, hostname) {
  const plAction = {
    type: 'API',
    types: [types.LOGIN, types.LOGIN_FULFILLED, types.LOGIN_REJECTED],
    api: doPostLogin(code, protocol, hostname),
    sso: true,
  };
  return plAction;
}

function clearLoginStatus() {
  return {
    type: types.CLEAR_LOGIN_STATUS
  };
}

const actions = {
  postLogin,
  clearLoginStatus
};

export {
  types,
  actions
};